module.exports = __webpack_public_path__ + "media/images/athletes/130-bb2d34769ddf51961b740b898710cf92.png";